export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'ar', label: 'العربية', flag: '🇲🇦', rtl: true },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
];

export const T = {
  en: {
    tagline: 'THE TABLE QUIZ',
    imHost: '🎙️ I\'m the Host',
    imPlayer: '📱 I\'m a Player',
    howToPlay: '❓ How to Play',
    joinGame: 'Join a Game',
    yourName: 'YOUR NAME',
    roomCode: 'ROOM CODE',
    joinBtn: 'Join Game →',
    waitingHost: 'Waiting for the host to start the game...',
    youJoinedAs: 'YOU JOINED AS',
    question: 'QUESTION',
    of: 'OF',
    wait: 'WAIT',
    listenQuestion: 'Listen to the question...',
    buzzIn: 'BUZZ IN',
    pressFirst: 'Press first if you know!',
    youBuzzed: 'YOU BUZZED!',
    answerOutLoud: 'Answer out loud to the host',
    wrong: 'WRONG!',
    hostWillTry: 'The host will try the next player',
    locked: 'LOCKED',
    buzzedFirst: 'buzzed first',
    nextQuestion: 'Next question coming...',
    wellDone: 'Well done!',
    thatsYou: "That's you!",
    winner: 'WINNER',
    backHome: '🏠 Back to Home',
    playAgain: '🔄 Play Again',
    room: 'Room',
    roomFull: '❌ This game is full (max 6 players)',
    chooseLanguage: 'Choose your language',
    back: '← Back',
    hostBadge: '🎙️ HOST',
    upgrade: '⭐ Upgrade',
    playersLabel: 'PLAYERS',
    scanQR: 'Players scan this QR code to join',
    orTypeCode: 'or type the room code manually',
    startGame: '▶ Start Game',
    players: 'players',
    waitingPlayers: 'Waiting for players to join...',
    freeTime: 'FREE TIME',
    readingBadge: '📖 Reading',
    gameOverBadge: '🏆 Game Over',
    buzzersOpenBadge: '🔔 Buzzers Open',
    questionReadOut: 'QUESTION — READ OUT LOUD',
    readQuestionInstruction: 'Read the question out loud, then open buzzers.',
    openBuzzersBtn: '🔓 OPEN BUZZERS',
    waitingBuzz: 'Waiting for players to buzz...',
    buzzedFirstAlert: 'buzzed first!',
    correctAnswerLabel: '✅ CORRECT ANSWER',
    buzzOrderLabel: 'BUZZ ORDER',
    correctBtn: '✅ CORRECT +100',
    wrongBtn: '❌ WRONG',
    to: 'to',
    discussAnswer: 'Discuss the answer, then continue.',
    seeResults: '🏆 See Results',
    nextQuestionBtn: '➡ NEXT QUESTION',
    gameOverTitle: 'Game Over!',
    finalResults: 'Final Results',
    revealWinner: '🎉 Reveal Winner to All Players',
    winnerRevealedMsg: '✅ Winner revealed to all players!',
    newGame: '🎮 New Game',
    home: '🏠 Home',
    liveLeaderboard: 'LIVE LEADERBOARD',
    pts: 'pts',
    createGameBadge: '🎮 CREATE GAME',
    questionsReady: 'questions ready',
    tapToReview: 'Tap to review →',
    tabSaved: '💾 Saved',
    tabCreate: '✏️ Create',
    tabCategories: '📚 Categories',
    tabAI: '🤖 AI',
    savedQuizzesDesc: 'Your saved quizzes — load one and start instantly.',
    noSavedGames: 'No saved games yet.',
    createAndSave: 'Create one and save it.',
    questionsCountLabel: 'questions',
    editBtn: '✏️ Edit',
    startNow: '🚀 Start Now',
    gameNameLabel: 'GAME NAME',
    gameNamePlaceholder: 'e.g. Friday Night Quiz',
    pointsPerQuestion: 'POINTS PER QUESTION',
    editingQ: '✏️ Editing Q',
    addQuestionTitle: '➕ Add Question',
    correctAnswerInputLabel: 'CORRECT ANSWER',
    questionPlaceholder: 'Type your question...',
    answerPlaceholder: 'The correct answer...',
    saveEdit: '✅ Save Edit',
    addBtn: '➕ Add',
    cancelBtn: 'Cancel',
    questionsPlural: 'QUESTIONS',
    noQuestionsYet: 'No questions yet — add above or use the Categories tab',
    saveBtn: '💾 Save',
    startGameBtn: '🚀 Start Game',
    chooseCategory: 'Choose a category then a subcategory.',
    subcategoriesLabel: 'subcategories',
    questionsAvailable: 'questions available',
    howManyQuestions: 'HOW MANY QUESTIONS?',
    moreQuestions: 'more questions...',
    addQuestionsBtn: 'Add',
    questionsWordCap: 'Questions',
    startQuiz: '🚀 Start Quiz',
    aiDescription: 'Type any topic and the AI will generate questions instantly.',
    popularTopics: 'POPULAR TOPICS',
    orTypeOwn: 'OR TYPE YOUR OWN TOPIC',
    aiTopicPlaceholder: 'e.g. Morocco, Space, Harry Potter...',
    howManyLabel: 'HOW MANY?',
    generating: '⏳ Generating...',
    generateQuestions: '🤖 Generate Questions',
    questionsGenerated: 'QUESTIONS GENERATED',
    addToQuiz: '➕ Add to Quiz',
    gameSavedAlert: 'Game saved! ✅',
    chooseDisplayLanguages: '🌍 Choose Display Languages',
    displayLanguagesDesc: 'Pick which languages to show during the game.',
    selectAtLeastOne: 'Select at least one language',
    launchGame: '🚀 Launch Game',
    howToPlayTitle: 'How to Play',
    howToPlayIntro: 'TabliQ is a live quiz game you play at the table. One host, everyone else plays on their phone.',
    htpStep1Title: 'Host creates a game',
    htpStep1Desc: 'The host signs in, adds questions or picks from the question bank, and starts the game. A room code and QR code appear on screen.',
    htpStep2Title: 'Players join',
    htpStep2Desc: 'Each player scans the QR code or types the 4-letter room code on their phone. No sign-up needed — just enter your name.',
    htpStep3Title: 'Host reads the question',
    htpStep3Desc: 'The host reads the question out loud to the table. Players see the question on their phone but the buzz button is locked.',
    htpStep4Title: 'Buzzers open',
    htpStep4Desc: "The host taps Open Buzzers. Every player's buzz button unlocks at the exact same moment. First to tap wins the right to answer.",
    htpStep5Title: 'First buzz wins',
    htpStep5Desc: 'The host sees who buzzed first with millisecond precision. That player answers out loud. If correct, they get points. If wrong, the next player gets a chance.',
    htpStep6Title: 'Winner takes the table',
    htpStep6Desc: 'After all questions the host reveals the winner to everyone. The leaderboard shows final scores for all players.',
    htpTipsTitle: '💡 Tips for the best game',
    htpTip1: 'Put all phones face down until buzzers open — no cheating!',
    htpTip2: 'The host should read questions clearly and at a steady pace',
    htpTip3: 'Mix easy and hard questions to keep everyone engaged',
    htpTip4: 'Play in rounds of 10 questions for the best pacing',
  },
  fr: {
    tagline: 'LE QUIZ DE TABLE',
    imHost: '🎙️ Je suis l\'animateur',
    imPlayer: '📱 Je suis un joueur',
    howToPlay: '❓ Comment jouer',
    joinGame: 'Rejoindre une partie',
    yourName: 'VOTRE NOM',
    roomCode: 'CODE DE SALLE',
    joinBtn: 'Rejoindre →',
    waitingHost: 'En attente du début de la partie...',
    youJoinedAs: 'VOUS JOUEZ EN TANT QUE',
    question: 'QUESTION',
    of: 'SUR',
    wait: 'ATTENDEZ',
    listenQuestion: 'Écoutez la question...',
    buzzIn: 'BUZZER',
    pressFirst: 'Appuyez en premier si vous savez!',
    youBuzzed: 'VOUS AVEZ BUZZÉ!',
    answerOutLoud: 'Répondez à voix haute à l\'animateur',
    wrong: 'FAUX!',
    hostWillTry: 'L\'animateur va essayer le joueur suivant',
    locked: 'BLOQUÉ',
    buzzedFirst: 'a buzzé en premier',
    nextQuestion: 'Prochaine question...',
    wellDone: 'Bravo!',
    thatsYou: "C'est vous!",
    winner: 'GAGNANT',
    backHome: '🏠 Accueil',
    playAgain: '🔄 Rejouer',
    room: 'Salle',
    roomFull: '❌ Cette partie est complète (max 6 joueurs)',
    chooseLanguage: 'Choisissez votre langue',
    back: '← Retour',
    hostBadge: '🎙️ ANIMATEUR',
    upgrade: '⭐ Améliorer',
    playersLabel: 'JOUEURS',
    scanQR: 'Les joueurs scannent ce QR code pour rejoindre',
    orTypeCode: 'ou tapent le code de la salle manuellement',
    startGame: '▶ Commencer',
    players: 'joueurs',
    waitingPlayers: 'En attente des joueurs...',
    freeTime: 'TEMPS GRATUIT',
    readingBadge: '📖 Lecture',
    gameOverBadge: '🏆 Fin du jeu',
    buzzersOpenBadge: '🔔 Buzzers ouverts',
    questionReadOut: 'QUESTION — LIRE À VOIX HAUTE',
    readQuestionInstruction: 'Lisez la question à voix haute, puis ouvrez les buzzers.',
    openBuzzersBtn: '🔓 OUVRIR BUZZERS',
    waitingBuzz: 'En attente que les joueurs buzzent...',
    buzzedFirstAlert: 'a buzzé en premier!',
    correctAnswerLabel: '✅ BONNE RÉPONSE',
    buzzOrderLabel: 'ORDRE DES BUZZ',
    correctBtn: '✅ CORRECT +100',
    wrongBtn: '❌ FAUX',
    to: 'à',
    discussAnswer: 'Discutez de la réponse, puis continuez.',
    seeResults: '🏆 Voir les résultats',
    nextQuestionBtn: '➡ QUESTION SUIVANTE',
    gameOverTitle: 'Fin du jeu!',
    finalResults: 'Résultats finaux',
    revealWinner: '🎉 Révéler le gagnant à tous',
    winnerRevealedMsg: '✅ Gagnant révélé à tous les joueurs!',
    newGame: '🎮 Nouvelle partie',
    home: '🏠 Accueil',
    liveLeaderboard: 'CLASSEMENT EN DIRECT',
    pts: 'pts',
    createGameBadge: '🎮 CRÉER UNE PARTIE',
    questionsReady: 'questions prêtes',
    tapToReview: 'Toucher pour revoir →',
    tabSaved: '💾 Sauvegardés',
    tabCreate: '✏️ Créer',
    tabCategories: '📚 Catégories',
    tabAI: '🤖 IA',
    savedQuizzesDesc: 'Vos quiz sauvegardés — chargez-en un et commencez.',
    noSavedGames: 'Aucune partie sauvegardée.',
    createAndSave: 'Créez-en une et sauvegardez.',
    questionsCountLabel: 'questions',
    editBtn: '✏️ Modifier',
    startNow: '🚀 Démarrer',
    gameNameLabel: 'NOM DE LA PARTIE',
    gameNamePlaceholder: 'ex. Quiz du Vendredi',
    pointsPerQuestion: 'POINTS PAR QUESTION',
    editingQ: '✏️ Modification Q',
    addQuestionTitle: '➕ Ajouter une question',
    correctAnswerInputLabel: 'BONNE RÉPONSE',
    questionPlaceholder: 'Tapez votre question...',
    answerPlaceholder: 'La bonne réponse...',
    saveEdit: '✅ Enregistrer',
    addBtn: '➕ Ajouter',
    cancelBtn: 'Annuler',
    questionsPlural: 'QUESTIONS',
    noQuestionsYet: 'Pas encore de questions — ajoutez ci-dessus ou utilisez l\'onglet Catégories',
    saveBtn: '💾 Sauvegarder',
    startGameBtn: '🚀 Commencer',
    chooseCategory: 'Choisissez une catégorie puis une sous-catégorie.',
    subcategoriesLabel: 'sous-catégories',
    questionsAvailable: 'questions disponibles',
    howManyQuestions: 'COMBIEN DE QUESTIONS?',
    moreQuestions: 'autres questions...',
    addQuestionsBtn: 'Ajouter',
    questionsWordCap: 'Questions',
    startQuiz: '🚀 Commencer Quiz',
    aiDescription: 'Tapez un sujet et l\'IA générera des questions instantanément.',
    popularTopics: 'SUJETS POPULAIRES',
    orTypeOwn: 'OU TAPEZ VOTRE PROPRE SUJET',
    aiTopicPlaceholder: 'ex. Maroc, Espace, Harry Potter...',
    howManyLabel: 'COMBIEN?',
    generating: '⏳ Génération...',
    generateQuestions: '🤖 Générer des questions',
    questionsGenerated: 'QUESTIONS GÉNÉRÉES',
    addToQuiz: '➕ Ajouter au quiz',
    gameSavedAlert: 'Partie sauvegardée! ✅',
    chooseDisplayLanguages: '🌍 Choisir les langues d\'affichage',
    displayLanguagesDesc: 'Choisissez les langues à afficher pendant le jeu.',
    selectAtLeastOne: 'Sélectionnez au moins une langue',
    launchGame: '🚀 Lancer la partie',
    howToPlayTitle: 'Comment Jouer',
    howToPlayIntro: 'TabliQ est un jeu de quiz en direct à jouer autour de la table. Un animateur, tout le monde joue sur son téléphone.',
    htpStep1Title: "L'animateur crée une partie",
    htpStep1Desc: "L'animateur se connecte, ajoute des questions ou les choisit dans la banque de questions, puis lance la partie. Un code de salle et un QR code apparaissent à l'écran.",
    htpStep2Title: 'Les joueurs rejoignent',
    htpStep2Desc: "Chaque joueur scanne le QR code ou tape le code de salle à 4 lettres sur son téléphone. Pas besoin de compte — il suffit d'entrer son nom.",
    htpStep3Title: "L'animateur lit la question",
    htpStep3Desc: "L'animateur lit la question à voix haute. Les joueurs voient la question sur leur téléphone mais le bouton buzzer est verrouillé.",
    htpStep4Title: "Les buzzers s'ouvrent",
    htpStep4Desc: "L'animateur appuie sur Ouvrir Buzzers. Le bouton de chaque joueur se déverrouille au même moment. Le premier à appuyer gagne le droit de répondre.",
    htpStep5Title: 'Le premier buzz gagne',
    htpStep5Desc: "L'animateur voit qui a buzzé en premier à la milliseconde près. Ce joueur répond à voix haute. S'il a juste, il gagne des points. Sinon, le joueur suivant a sa chance.",
    htpStep6Title: 'Le gagnant remporte la table',
    htpStep6Desc: "Après toutes les questions, l'animateur révèle le gagnant à tout le monde. Le classement affiche les scores finaux.",
    htpTipsTitle: '💡 Conseils pour une super partie',
    htpTip1: "Posez tous les téléphones face cachée jusqu'à l'ouverture des buzzers — pas de triche!",
    htpTip2: "L'animateur doit lire les questions clairement et à un rythme régulier",
    htpTip3: 'Mélangez questions faciles et difficiles pour garder tout le monde engagé',
    htpTip4: 'Jouez par manches de 10 questions pour un rythme optimal',
  },
  ar: {
    tagline: 'كويز الطاولة',
    imHost: '🎙️ أنا المضيف',
    imPlayer: '📱 أنا لاعب',
    howToPlay: '❓ كيف تلعب',
    joinGame: 'انضم إلى لعبة',
    yourName: 'اسمك',
    roomCode: 'رمز الغرفة',
    joinBtn: 'انضم →',
    waitingHost: 'في انتظار بدء المضيف للعبة...',
    youJoinedAs: 'انضممت باسم',
    question: 'سؤال',
    of: 'من',
    wait: 'انتظر',
    listenQuestion: 'استمع إلى السؤال...',
    buzzIn: 'اضغط',
    pressFirst: 'اضغط أولاً إذا كنت تعرف!',
    youBuzzed: 'ضغطت أولاً!',
    answerOutLoud: 'أجب بصوت عالٍ للمضيف',
    wrong: 'خطأ!',
    hostWillTry: 'سيحاول المضيف مع اللاعب التالي',
    locked: 'مقفل',
    buzzedFirst: 'ضغط أولاً',
    nextQuestion: 'السؤال التالي قادم...',
    wellDone: 'أحسنت!',
    thatsYou: 'هذا أنت!',
    winner: 'الفائز',
    backHome: '🏠 الرئيسية',
    playAgain: '🔄 العب مجدداً',
    room: 'غرفة',
    roomFull: '❌ اللعبة ممتلئة (6 لاعبين كحد أقصى)',
    chooseLanguage: 'اختر لغتك',
    back: '← رجوع',
    hostBadge: '🎙️ المضيف',
    upgrade: '⭐ ترقية',
    playersLabel: 'اللاعبون',
    scanQR: 'يمسح اللاعبون رمز QR للانضمام',
    orTypeCode: 'أو يكتبون رمز الغرفة يدوياً',
    startGame: '▶ ابدأ اللعبة',
    players: 'لاعبين',
    waitingPlayers: 'في انتظار انضمام اللاعبين...',
    freeTime: 'الوقت المجاني',
    readingBadge: '📖 قراءة',
    gameOverBadge: '🏆 انتهت اللعبة',
    buzzersOpenBadge: '🔔 الأزرار مفتوحة',
    questionReadOut: 'السؤال — اقرأ بصوت عالٍ',
    readQuestionInstruction: 'اقرأ السؤال بصوت عالٍ، ثم افتح الأزرار.',
    openBuzzersBtn: '🔓 افتح الأزرار',
    waitingBuzz: 'في انتظار ضغط اللاعبين...',
    buzzedFirstAlert: 'ضغط أولاً!',
    correctAnswerLabel: '✅ الإجابة الصحيحة',
    buzzOrderLabel: 'ترتيب الضغط',
    correctBtn: '✅ صحيح +100',
    wrongBtn: '❌ خطأ',
    to: 'لـ',
    discussAnswer: 'ناقشوا الإجابة، ثم تابعوا.',
    seeResults: '🏆 عرض النتائج',
    nextQuestionBtn: '➡ السؤال التالي',
    gameOverTitle: 'انتهت اللعبة!',
    finalResults: 'النتائج النهائية',
    revealWinner: '🎉 كشف الفائز لجميع اللاعبين',
    winnerRevealedMsg: '✅ تم كشف الفائز لجميع اللاعبين!',
    newGame: '🎮 لعبة جديدة',
    home: '🏠 الرئيسية',
    liveLeaderboard: 'لوحة المتصدرين المباشرة',
    pts: 'نقطة',
    createGameBadge: '🎮 إنشاء لعبة',
    questionsReady: 'أسئلة جاهزة',
    tapToReview: 'اضغط للمراجعة ←',
    tabSaved: '💾 المحفوظة',
    tabCreate: '✏️ إنشاء',
    tabCategories: '📚 الفئات',
    tabAI: '🤖 ذكاء',
    savedQuizzesDesc: 'الاختبارات المحفوظة — حمّل واحداً وابدأ فوراً.',
    noSavedGames: 'لا توجد ألعاب محفوظة.',
    createAndSave: 'أنشئ واحدة واحفظها.',
    questionsCountLabel: 'أسئلة',
    editBtn: '✏️ تعديل',
    startNow: '🚀 ابدأ الآن',
    gameNameLabel: 'اسم اللعبة',
    gameNamePlaceholder: 'مثال: كويز ليلة الجمعة',
    pointsPerQuestion: 'النقاط لكل سؤال',
    editingQ: '✏️ تعديل سؤال ',
    addQuestionTitle: '➕ أضف سؤالاً',
    correctAnswerInputLabel: 'الإجابة الصحيحة',
    questionPlaceholder: 'اكتب سؤالك...',
    answerPlaceholder: 'الإجابة الصحيحة...',
    saveEdit: '✅ حفظ التعديل',
    addBtn: '➕ أضف',
    cancelBtn: 'إلغاء',
    questionsPlural: 'أسئلة',
    noQuestionsYet: 'لا توجد أسئلة بعد — أضف أعلاه أو استخدم تبويب الفئات',
    saveBtn: '💾 حفظ',
    startGameBtn: '🚀 ابدأ اللعبة',
    chooseCategory: 'اختر فئة ثم فئة فرعية.',
    subcategoriesLabel: 'فئات فرعية',
    questionsAvailable: 'أسئلة متاحة',
    howManyQuestions: 'كم سؤالاً؟',
    moreQuestions: 'أسئلة أخرى...',
    addQuestionsBtn: 'أضف',
    questionsWordCap: 'أسئلة',
    startQuiz: '🚀 ابدأ الاختبار',
    aiDescription: 'اكتب أي موضوع وسينشئ الذكاء الاصطناعي أسئلة فوراً.',
    popularTopics: 'مواضيع شائعة',
    orTypeOwn: 'أو اكتب موضوعك الخاص',
    aiTopicPlaceholder: 'مثال: المغرب، الفضاء، هاري بوتر...',
    howManyLabel: 'كم؟',
    generating: '⏳ جاري الإنشاء...',
    generateQuestions: '🤖 إنشاء أسئلة',
    questionsGenerated: 'أسئلة تم إنشاؤها',
    addToQuiz: '➕ أضف إلى الاختبار',
    gameSavedAlert: 'تم حفظ اللعبة! ✅',
    chooseDisplayLanguages: '🌍 اختر لغات العرض',
    displayLanguagesDesc: 'اختر اللغات التي تريد عرضها أثناء اللعبة.',
    selectAtLeastOne: 'اختر لغة واحدة على الأقل',
    launchGame: '🚀 ابدأ اللعبة',
    howToPlayTitle: 'كيف تلعب',
    howToPlayIntro: 'تابليك هي لعبة كويز مباشرة تُلعب حول الطاولة. مضيف واحد، والباقي يلعبون على هواتفهم.',
    htpStep1Title: 'المضيف ينشئ لعبة',
    htpStep1Desc: 'يقوم المضيف بتسجيل الدخول، إضافة الأسئلة أو اختيارها من بنك الأسئلة، ثم يبدأ اللعبة. يظهر رمز الغرفة ورمز QR على الشاشة.',
    htpStep2Title: 'انضمام اللاعبين',
    htpStep2Desc: 'يقوم كل لاعب بمسح رمز QR أو كتابة رمز الغرفة المكون من 4 أحرف على هاتفه. لا حاجة للتسجيل — فقط أدخل اسمك.',
    htpStep3Title: 'المضيف يقرأ السؤال',
    htpStep3Desc: 'يقرأ المضيف السؤال بصوت عالٍ. يرى اللاعبون السؤال على هواتفهم لكن زر الضغط مقفل.',
    htpStep4Title: 'فتح الأزرار',
    htpStep4Desc: 'يضغط المضيف على فتح الأزرار. يُفتح زر الضغط لكل لاعب في نفس اللحظة بالضبط. أول من يضغط يفوز بحق الإجابة.',
    htpStep5Title: 'الضغط الأول يفوز',
    htpStep5Desc: 'يرى المضيف من ضغط أولاً بدقة الميلي ثانية. يجيب ذلك اللاعب بصوت عالٍ. إذا كانت إجابته صحيحة يحصل على نقاط. إذا كانت خاطئة، يحصل اللاعب التالي على فرصة.',
    htpStep6Title: 'الفائز يأخذ الطاولة',
    htpStep6Desc: 'بعد كل الأسئلة، يكشف المضيف الفائز للجميع. تعرض لوحة المتصدرين النتائج النهائية لجميع اللاعبين.',
    htpTipsTitle: '💡 نصائح لأفضل لعبة',
    htpTip1: 'ضعوا جميع الهواتف بوجهها للأسفل حتى تُفتح الأزرار — لا غش!',
    htpTip2: 'يجب على المضيف قراءة الأسئلة بوضوح وبإيقاع ثابت',
    htpTip3: 'امزجوا الأسئلة السهلة والصعبة للحفاظ على تفاعل الجميع',
    htpTip4: 'العبوا بجولات من 10 أسئلة للحصول على أفضل إيقاع',
  },
  es: {
    tagline: 'EL QUIZ DE MESA',
    imHost: '🎙️ Soy el anfitrión',
    imPlayer: '📱 Soy un jugador',
    howToPlay: '❓ Cómo jugar',
    joinGame: 'Unirse a un juego',
    yourName: 'TU NOMBRE',
    roomCode: 'CÓDIGO DE SALA',
    joinBtn: 'Unirse →',
    waitingHost: 'Esperando que el anfitrión inicie el juego...',
    youJoinedAs: 'TE HAS UNIDO COMO',
    question: 'PREGUNTA',
    of: 'DE',
    wait: 'ESPERA',
    listenQuestion: 'Escucha la pregunta...',
    buzzIn: 'PULSAR',
    pressFirst: '¡Pulsa primero si sabes la respuesta!',
    youBuzzed: '¡HAS PULSADO!',
    answerOutLoud: 'Responde en voz alta al anfitrión',
    wrong: '¡INCORRECTO!',
    hostWillTry: 'El anfitrión probará con el siguiente jugador',
    locked: 'BLOQUEADO',
    buzzedFirst: 'pulsó primero',
    nextQuestion: 'Siguiente pregunta...',
    wellDone: '¡Bien hecho!',
    thatsYou: '¡Eres tú!',
    winner: 'GANADOR',
    backHome: '🏠 Inicio',
    playAgain: '🔄 Jugar de nuevo',
    room: 'Sala',
    roomFull: '❌ El juego está lleno (máx 6 jugadores)',
    chooseLanguage: 'Elige tu idioma',
    back: '← Atrás',
    hostBadge: '🎙️ ANFITRIÓN',
    upgrade: '⭐ Mejorar',
    playersLabel: 'JUGADORES',
    scanQR: 'Los jugadores escanean este código QR para unirse',
    orTypeCode: 'o escriben el código de sala manualmente',
    startGame: '▶ Empezar',
    players: 'jugadores',
    waitingPlayers: 'Esperando jugadores...',
    freeTime: 'TIEMPO GRATIS',
    readingBadge: '📖 Leyendo',
    gameOverBadge: '🏆 Fin del juego',
    buzzersOpenBadge: '🔔 Pulsadores abiertos',
    questionReadOut: 'PREGUNTA — LEER EN VOZ ALTA',
    readQuestionInstruction: 'Lee la pregunta en voz alta, luego abre los pulsadores.',
    openBuzzersBtn: '🔓 ABRIR PULSADORES',
    waitingBuzz: 'Esperando a que los jugadores pulsen...',
    buzzedFirstAlert: '¡pulsó primero!',
    correctAnswerLabel: '✅ RESPUESTA CORRECTA',
    buzzOrderLabel: 'ORDEN DE PULSACIÓN',
    correctBtn: '✅ CORRECTO +100',
    wrongBtn: '❌ INCORRECTO',
    to: 'para',
    discussAnswer: 'Discute la respuesta, luego continúa.',
    seeResults: '🏆 Ver resultados',
    nextQuestionBtn: '➡ SIGUIENTE PREGUNTA',
    gameOverTitle: '¡Fin del juego!',
    finalResults: 'Resultados finales',
    revealWinner: '🎉 Revelar ganador a todos',
    winnerRevealedMsg: '✅ ¡Ganador revelado a todos!',
    newGame: '🎮 Nueva partida',
    home: '🏠 Inicio',
    liveLeaderboard: 'CLASIFICACIÓN EN VIVO',
    pts: 'pts',
    createGameBadge: '🎮 CREAR PARTIDA',
    questionsReady: 'preguntas listas',
    tapToReview: 'Toca para revisar →',
    tabSaved: '💾 Guardadas',
    tabCreate: '✏️ Crear',
    tabCategories: '📚 Categorías',
    tabAI: '🤖 IA',
    savedQuizzesDesc: 'Tus quizzes guardados — carga uno y empieza al instante.',
    noSavedGames: 'No hay partidas guardadas.',
    createAndSave: 'Crea una y guárdala.',
    questionsCountLabel: 'preguntas',
    editBtn: '✏️ Editar',
    startNow: '🚀 Iniciar Ahora',
    gameNameLabel: 'NOMBRE DE LA PARTIDA',
    gameNamePlaceholder: 'ej. Quiz del Viernes',
    pointsPerQuestion: 'PUNTOS POR PREGUNTA',
    editingQ: '✏️ Editando P',
    addQuestionTitle: '➕ Añadir Pregunta',
    correctAnswerInputLabel: 'RESPUESTA CORRECTA',
    questionPlaceholder: 'Escribe tu pregunta...',
    answerPlaceholder: 'La respuesta correcta...',
    saveEdit: '✅ Guardar Edición',
    addBtn: '➕ Añadir',
    cancelBtn: 'Cancelar',
    questionsPlural: 'PREGUNTAS',
    noQuestionsYet: 'Sin preguntas aún — añade arriba o usa la pestaña Categorías',
    saveBtn: '💾 Guardar',
    startGameBtn: '🚀 Empezar Partida',
    chooseCategory: 'Elige una categoría y luego una subcategoría.',
    subcategoriesLabel: 'subcategorías',
    questionsAvailable: 'preguntas disponibles',
    howManyQuestions: '¿CUÁNTAS PREGUNTAS?',
    moreQuestions: 'preguntas más...',
    addQuestionsBtn: 'Añadir',
    questionsWordCap: 'Preguntas',
    startQuiz: '🚀 Empezar Quiz',
    aiDescription: 'Escribe un tema y la IA generará preguntas al instante.',
    popularTopics: 'TEMAS POPULARES',
    orTypeOwn: 'O ESCRIBE TU PROPIO TEMA',
    aiTopicPlaceholder: 'ej. Marruecos, Espacio, Harry Potter...',
    howManyLabel: '¿CUÁNTAS?',
    generating: '⏳ Generando...',
    generateQuestions: '🤖 Generar Preguntas',
    questionsGenerated: 'PREGUNTAS GENERADAS',
    addToQuiz: '➕ Añadir al Quiz',
    gameSavedAlert: '¡Partida guardada! ✅',
    chooseDisplayLanguages: '🌍 Elegir idiomas de visualización',
    displayLanguagesDesc: 'Elige qué idiomas mostrar durante el juego.',
    selectAtLeastOne: 'Selecciona al menos un idioma',
    launchGame: '🚀 Iniciar Juego',
    howToPlayTitle: 'Cómo Jugar',
    howToPlayIntro: 'TabliQ es un juego de quiz en vivo para jugar en la mesa. Un anfitrión, todos los demás juegan en su teléfono.',
    htpStep1Title: 'El anfitrión crea una partida',
    htpStep1Desc: 'El anfitrión inicia sesión, añade preguntas o las elige del banco de preguntas, y empieza la partida. Aparecen un código de sala y un código QR en la pantalla.',
    htpStep2Title: 'Los jugadores se unen',
    htpStep2Desc: 'Cada jugador escanea el código QR o escribe el código de sala de 4 letras en su teléfono. No hace falta registrarse — solo introduce tu nombre.',
    htpStep3Title: 'El anfitrión lee la pregunta',
    htpStep3Desc: 'El anfitrión lee la pregunta en voz alta. Los jugadores ven la pregunta en su teléfono pero el botón de pulsar está bloqueado.',
    htpStep4Title: 'Se abren los pulsadores',
    htpStep4Desc: 'El anfitrión toca Abrir Pulsadores. El botón de cada jugador se desbloquea en el mismo instante. El primero en pulsar gana el derecho a responder.',
    htpStep5Title: 'El primer pulsado gana',
    htpStep5Desc: 'El anfitrión ve quién pulsó primero con precisión de milisegundos. Ese jugador responde en voz alta. Si acierta, gana puntos. Si falla, el siguiente jugador tiene una oportunidad.',
    htpStep6Title: 'El ganador se lleva la mesa',
    htpStep6Desc: 'Después de todas las preguntas, el anfitrión revela el ganador a todos. La clasificación muestra los resultados finales de todos los jugadores.',
    htpTipsTitle: '💡 Consejos para la mejor partida',
    htpTip1: '¡Pon todos los teléfonos boca abajo hasta que se abran los pulsadores — sin trampas!',
    htpTip2: 'El anfitrión debe leer las preguntas con claridad y a un ritmo constante',
    htpTip3: 'Mezcla preguntas fáciles y difíciles para mantener a todos enganchados',
    htpTip4: 'Juega en rondas de 10 preguntas para el mejor ritmo',
  },
};